import { render, staticRenderFns } from "./BaseSubmitDangerModal.vue?vue&type=template&id=1ce69579&scoped=true&"
import script from "./BaseSubmitDangerModal.vue?vue&type=script&lang=js&"
export * from "./BaseSubmitDangerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce69579",
  null
  
)

export default component.exports